/**
 * TKP-143 / tasarım s.33 md.2b "ekran dönüşleri" (karar 2026-09-27): çalışma alanı panelinin her alt ekranında
 * "Çalışma Alanlarım › <seçili çalışma alanı> › <ekran>" kırıntısı; ilk kırıntı listeye döner. Saf yardımcı, layout'ta kullanılır.
 */
export const WORKSPACE_LIST_PATH = "/workspace";

/** Ekran adı anahtarı: yol → çeviri anahtarı; ana ekran (liste) ve bilinmeyen yol için `null`. */
export const screenLabelKey = (path) => {
  const p = String(path || "").replace(/\/+$/, "");
  if (p === WORKSPACE_LIST_PATH || p === "" || p === `${WORKSPACE_LIST_PATH}/workspaces`) return null;
  if (p === `${WORKSPACE_LIST_PATH}/organizations`) return "organization.plural";
  if (p === `${WORKSPACE_LIST_PATH}/members` || p.startsWith(`${WORKSPACE_LIST_PATH}/member/`)) return "workspace.members";
  if (p.startsWith(`${WORKSPACE_LIST_PATH}/library/`)) return "common.library";
  if (p === `${WORKSPACE_LIST_PATH}/edit`) return "workspace.settings";
  return null;
};

/**
 * Kırıntılar: [{ label, to? }] — sonuncusu etkin (bağlantısız). Ana ekranda boş dizi (kırıntı çizilmez).
 * Çalışma alanı seçili değilse orta kırıntı düşer (kapı zaten listeye yönlendirir, ama çizim yine de kırılmaz).
 */
export const crumbsFor = (path, workspace, t) => {
  const key = screenLabelKey(path);
  if (!key) return [];
  const crumbs = [{ label: t("workspace.my"), to: WORKSPACE_LIST_PATH }];
  if (workspace && workspace.name) crumbs.push({ label: workspace.name });
  crumbs.push({ label: t(key) });
  return crumbs;
};
